module.exports = __webpack_public_path__ + "media/images/new_culture/factor-goals-5b8aacaf1e13f0225cd13348b8c3b159.png";